import React, { useState, useEffect } from "react";
import LoadingWidget from "./LoadingWidget";

function Widget() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="absolute top-2 right-10">
        <LoadingWidget />
      </div>
    );
  }

  return (
    <div className="absolute bottom-3 right-12">
      <div className="elfsight-app-b8a56f1e-13f0-420d-a542-091d4e218b2d"></div>
    </div>
  );
}

export default Widget;
